/* @jsx h */
import { h } from "preact";
import BasicList from "../BasicList";
import { useChecklistContext } from "../../context";
import { AccordionItem } from "@ingka/accordion";
import Accordion from "@ingka/accordion";
import Hyperlink from "@ingka/hyperlink";
import PropTypes from "prop-types";
import variables from "/src/scss/variables.module.scss";
import "./sublist.scss";
import { sendGASublistLinkClick } from "../../helpers";

/*
 * Associated with checklist product categories. 
 * Sublists consist of header, and basic "todo" lists, and "completed" lists.
 */
function Sublist({ sublist }) {
    const { prefix: stylePrefix } = variables;
    const { id, title, items, url } = sublist;
    const { userCheckedItems, onSublistChevronClick } = useChecklistContext();
    const todoList = items.filter((item) => !userCheckedItems.has(`${id}-${item.id}`));
    const completedList = items.filter((item) => userCheckedItems.has(`${id}-${item.id}`));
    const handleSublistClosedStateToggle = () => onSublistChevronClick(id);
    
    return (
        <div className="sublist">
            <Accordion open={true} padded={false} prefix={stylePrefix}>
                <AccordionItem
                    title={title}
                    id={id}
                    open={true}
                    prefix={stylePrefix}
                    onHeadingClicked={handleSublistClosedStateToggle}
                >
                    {url && (
                        <Hyperlink
                            prefix={stylePrefix}
                            text={`Shop Online`}
                            url={url}
                            colour={"grey"}
                            newWindow={true}
                            onClick={sendGASublistLinkClick}
                        />
                    )}
                    {todoList.length > 0 && <BasicList checked={false} items={todoList} sublistId={id} />}
                    {completedList.length > 0 && <BasicList checked={true} items={completedList} sublistId={id} />}
                </AccordionItem>
            </Accordion>
        </div>
    );
}

Sublist.propTypes = {
    sublist: PropTypes.object
};
export default Sublist;
